import { z } from "zod/v4";

import { ExperienceAnalysisDtoSchema } from "../../../dtos/experience-analysis";
import {
  CreateExperienceCustomMetricDtoSchema,
  ExperienceCustomMetricDtoSchema,
} from "../../../dtos/experience-custom-metrics";
import {
  CreateExperienceKeyMetricDtoSchema,
  ExperienceKeyMetricDtoSchema,
} from "../../../dtos/experience-key-metrics";
import { ProductVariantProductTypeList } from "../../../dtos/product-variants";
import { S3FileLocationDtoSchema } from "../../../dtos/s3-file-location";

export const PutConfigureAnalyticsRequestBodySchema = z.object({
  experienceKeyMetrics: CreateExperienceKeyMetricDtoSchema.array().default([]),
  experienceCustomMetrics:
    CreateExperienceCustomMetricDtoSchema.array().default([]),
  experienceAnalysis: ExperienceAnalysisDtoSchema,
  productsLocation: S3FileLocationDtoSchema.nullish(),
});

export type PutConfigureAnalyticsRequestBody = z.infer<
  typeof PutConfigureAnalyticsRequestBodySchema
>;

export const PutConfigureAnalyticsResponseBodySchema = z.object({
  experienceKeyMetrics: ExperienceKeyMetricDtoSchema.array().default([]),
  experienceCustomMetrics: ExperienceCustomMetricDtoSchema.array().default([]),
  experienceAnalysis: ExperienceAnalysisDtoSchema,
});

export type PutConfigureAnalyticsResponseBody = z.infer<
  typeof PutConfigureAnalyticsResponseBodySchema
>;

export const PutConfigureAnalyticsRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type PutConfigureAnalyticsRequestPathParamType = z.infer<
  typeof PutConfigureAnalyticsRequestPathParamSchema
>;
